export default __webpack_public_path__ + "static/media/path1.96331d28.svg";